module.exports = __webpack_public_path__ + "img/yaroshetskiy.6333a0c7.jpg";